import { addOrgPrefix, addProgPrefix } from '@/utils/routes';

/**
 * Build a dashboard URL directly from notification metadata.
 *
 * All current notification types (case_assigned, case_reassigned,
 * case_needs_action, manual_task_assigned) include organization_id,
 * program_id, and case_record_id in their metadata.
 */
export function buildUrlFromMetadata(metadata: Record<string, unknown>): string | null {
  const orgId = metadata.organization_id;
  const progId = metadata.program_id;
  const caseId = metadata.case_record_id;

  if (typeof orgId !== 'string' || !orgId) return null;
  if (typeof progId !== 'string' || !progId) return null;
  if (typeof caseId !== 'string' || !caseId) return null;

  return `${window.location.origin}/${addOrgPrefix(orgId)}/${addProgPrefix(progId)}/cases/${caseId}`;
}
